<script setup lang="ts">
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';
import { ReserveType } from '@utils/itinerary';
import { SearchMode } from '@utils/types';

useCheckLandingContent();
const contentStore = useContentStore();
const trainForm = useTrainForm();
const { setReserveType } = useSearchFormStore();
const route = useRoute();
const match = route.path.match(/trains\/(\d+)\/?$/);
const destination = ((route.params.code || (match && match[1])) ??
    '') as string;
if (/\d{1,3}/.test(destination)) {
    const destinationCode = await trainForm.findCodeBaseOnStationId(
        Number(destination),
        { mode: SearchMode.Domestic, target: 'destination' }
    );
    navigateTo(
        {
            path: `/trains/${destinationCode}`,
            query: route.query,
        },
        { redirectCode: 301 }
    );
}
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: `https://mrbilit.com${route.path.replace(/\/$/, '')}`,
        },
    ],
});

const { landingCityName } = classToRefs(contentStore);
onMounted(async () => {
    setReserveType(ReserveType.Train);
    await trainForm.loadLandingSearchParams(destination);
});
definePageMeta({
    breadcrumbs: JSON.stringify([
        { title: 'مِستربلیط', link: '/' },
        { title: 'بلیط قطار', link: '/train-ticket' },
        { title: 'بلیط قطار $cityName', link: '$routePath' },
    ]),
});
</script>
<template>
    <InformationContainer
        :title="`راهنمای خرید اینترنتی قطار ${landingCityName} از مِستربلیط`"
    />
</template>
